import { createSelector } from 'reselect';
import { emptyArray } from '../../../constants';
import { defaultSpaceInvites } from './spaces';
export const selectSelectedSpace = (store) => store.spaces.selectedSpace;
export const selectPreviousSelectedSpace = (store) => store.spaces.previousSpace;
export const selectSpaceInvitesWithStatus = (store, spaceId) => store.spaces.spaceInvites[spaceId] || defaultSpaceInvites;
export const selectSpaceInfo = (store) => store.spaces.spaceInfo;
export const selectFetchingMySpaces = (store) => store.spaces.fetchingMySpaces;
export const selectSpaces = createSelector([selectSpaceInfo], (spaceInfo) => spaceInfo
    ? Object.values(spaceInfo)
        .map((spaceInfo) => spaceInfo?.space)
        .filter((space) => !!space)
    : emptyArray);
export const selectExpiredSpacesCount = createSelector([selectSpaces], (spaces) => spaces.filter((space) => !space.isDefault && !space.isPremium).length);
export const selectHasSpaces = createSelector([selectSpaces], 
// A user should always have 1 space (their default space)
(spaces) => spaces && spaces?.length > 1);
export const selectSelectedSpaceData = createSelector([selectSelectedSpace, selectSpaces], (selectedId, spaces) => spaces?.find((space) => space?.id === selectedId));
export const selectIsDefaultSpace = createSelector(selectSelectedSpaceData, (selectedSpaceData) => {
    if (!selectedSpaceData || selectedSpaceData.isDefault) {
        return true;
    }
    return false;
});
const spaceById = (selectedId, spaces) => selectedId !== undefined && spaces !== undefined
    ? spaces[selectedId]
    : undefined;
export const selectSelectedSpaceInfo = createSelector([selectSelectedSpace, selectSpaceInfo], spaceById);
export const selectPreviousSelectedSpaceInfo = createSelector([selectPreviousSelectedSpace, selectSpaceInfo], spaceById);
export const selectSpaceInfoById = createSelector([
    selectSpaceInfo,
    selectSelectedSpace,
    (_, spaceId) => spaceId,
], (spaceInfo, selectedSpace, spaceId) => spaceById(spaceId || selectedSpace, spaceInfo));
export const selectDefaultSpace = createSelector([selectSpaces], (spaces) => spaces.find((space) => space.isDefault));
export const selectDefaultSpaceId = createSelector([selectDefaultSpace], (space) => space?.id);
export const selectSpaceInfoForExtraMemberSuggestion = createSelector([
    selectSpaceInfoById,
    selectSpaceInvitesWithStatus,
    (_, spaceId) => spaceId,
], (spaceInfo, { pending }, spaceId) => {
    if (!spaceId)
        return null;
    if (spaceInfo) {
        const users = [];
        spaceInfo.users?.forEach((user) => {
            if (user.id !== spaceInfo.space.createdBy) {
                users.push(user);
            }
        });
        pending.forEach((invite) => {
            users.push(invite.member);
        });
        if (users.length > 0) {
            return {
                spaceName: spaceInfo.space.name,
                users,
            };
        }
    }
    return null;
});
export const selectSpacesCreatedByUser = createSelector([selectSpaces, (state) => state.user.user.id], (spaces, userId) => spaces.filter((space) => space.createdBy === userId && !space.isDefault));
